import styled from "styled-components";
import { colorPalette, typeScale } from "../../../../utils/theme";

/** Sticky shell that hosts the floating capsule */
export const TopbarShell = styled.div`
  position: sticky;
  top: 0;
  z-index: 100;
  padding-top: 16px;
  padding-bottom: 32px;
  background: transparent;

  &.scrolled {
    /* slightly stronger blur when scrolling */
    ${"" /* the capsule handles most visuals */}
  }

  @media (max-width: 767.98px) {
    padding-top: 8px;
    padding-left: 16px;
    padding-right: 16px;
  }
`;

/** Frosted floating nav capsule */
export const Capsule = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: clamp(12px, 2vw, 24px);
  border-radius: 999px;
  padding: clamp(8px, 1.2vh, 12px) clamp(12px, 2vw, 20px);
  background: #ffffff80;
  border: 1px solid;
  border-image-source: linear-gradient(
    90.48deg,
    #ebf1f7 1.56%,
    rgba(235, 241, 247, 0) 13.3%,
    rgba(235, 241, 247, 0) 81.86%,
    #ebf1f7 97.37%
  );
  backdrop-filter: blur(20px);
  -webkit-backdrop-filter: blur(20px);
  box-shadow: 0px 4px 20px 0px #00000026;
  color: ${colorPalette.textMain};
  border: 1px solid;
  border-image-source: linear-gradient(
    90.48deg,
    #ebf1f7 1.56%,
    rgba(235, 241, 247, 0) 13.3%,
    rgba(235, 241, 247, 0) 81.86%,
    #ebf1f7 97.37%
  );
`;

/** Groups */
export const LeftGroup = styled.div`
  display: flex;
  align-items: center;
  gap: clamp(8px, 1.6vw, 16px);
`;

export const RightGroup = styled.div`
  display: flex;
  align-items: center;
  gap: clamp(12px, 2vw, 24px);
`;

export const MobileActions = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
`;

/** Logo */
export const LogoContainer = styled.div`
  cursor: pointer;
  display: flex;
  align-items: center;
  img {
    height: clamp(20px, 2.6vh, 28px);
    width: auto;
    display: block;
  }
`;

/** Segmented control (Landlord / Tenants) */
export const Segment = styled.div`
  display: inline-flex;
  gap: 6px;
  padding: 4px;
`;

export const SegBtn = styled.button`
  position: relative;
  border: 0;
  outline: none;
  cursor: pointer;
  border-radius: 999px;
  padding: 8px 16px;
  background: transparent;
  color: ${colorPalette.textMain};
  ${typeScale.bodyMD};

  &[data-active="true"] {
    background: ${colorPalette.white};
    color: ${colorPalette.textMain};
    box-shadow: 0 1px 0 rgba(0, 0, 0, 0.05);
  }

  &:disabled {
    opacity: 0.7;
    cursor: not-allowed;
  }
`;

/** Right-side links */
export const NavLinks = styled.nav`
  display: flex;
  align-items: center;
  gap: clamp(16px, 3vw, 40px);
`;

export const NavLinkItem = styled.button`
  background: transparent;
  border: 0;
  padding: 0.25rem 0;
  cursor: pointer;
  white-space: nowrap;
  color: ${colorPalette.textMain};
  ${typeScale.bodyLG};

  &:hover {
    opacity: 0.7;
  }
`;

/** Blue pill sign-in */
export const SignInButton = styled.button`
  border: 0;
  border-radius: 999px;
  padding: 0.6rem 1.1rem;
  background: ${colorPalette.blue500};
  color: ${colorPalette.white};
  ${typeScale.bodyMDMain};
  box-shadow: 0 8px 16px rgba(47, 107, 255, 0.25);

  &:hover {
    filter: brightness(0.98);
  }
  &:active {
    transform: translateY(1px);
  }
`;
